import { render } from "./TrainingCategory.vue?vue&type=template&id=1caa592b"
import script from "./TrainingCategory.vue?vue&type=script&lang=js"
export * from "./TrainingCategory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__